export const newslettercontent = {
  "title": "For Latest Updates",
  "subTag": "Never miss an update from us...",
  "purpose": "Delivered conveniently to your Inbox",
  "emailValidationError": "Kindly provide a valid email ID"
};
export const submitText = "Submit";